'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageStraighten = function ImageStraighten(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z' })
  );
};
ImageStraighten = (0, _pure2.default)(ImageStraighten);
ImageStraighten.displayName = 'ImageStraighten';
ImageStraighten.muiName = 'SvgIcon';

exports.default = ImageStraighten;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/straighten.js
 ** module id = 2151
 ** module chunks = 0
 **/